import { Component, OnInit, TemplateRef, AfterViewInit, OnDestroy, ViewChild } from "@angular/core";
import {
    CclNavbarFooterService,
    CclNavbarTemplates,
    CclTemplateResolverService,
    CclNavbarTemplateProviderComponent,
    CclMessageService,
    CclNavbarSecondaryService
} from "certain-common-library";
import { SharedService } from "../../modules/shared/services/shared.service";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import * as moment from 'moment';
import { DatePipe } from "@angular/common";

@Component({
    selector: "app-admin-feature",
    templateUrl: "./admin-feature.view.html",
    styleUrls: [],
    providers: []
})
export class AdminFeatureView implements OnInit, AfterViewInit {
    templates: TemplateRef<any>[];
    subscription: Subscription;
    datePipe = new DatePipe("en-US");
    @ViewChild('navbarItemExternalLinkCustom') navbarItemExternalLinkCustom: TemplateRef<any>;
    @ViewChild('navbarItemTitleCustom') navbarItemTitleCustom: TemplateRef<any>;

    constructor(
        private router: Router,
        private navbarFooterService: CclNavbarFooterService,
        private templateResolver: CclTemplateResolverService,
        public sharedService: SharedService,
        private messageService: CclMessageService,
        private navSecondaryService: CclNavbarSecondaryService
    ) {
        this.templates = this.templateResolver.getTemplates(CclNavbarTemplateProviderComponent, [
            CclNavbarTemplates.title,
            CclNavbarTemplates.button,
            CclNavbarTemplates.divider,
            CclNavbarTemplates.buttonShort
        ]);

        this.subscription = this.messageService.getMessage().subscribe((message) => this.handleMessage(message));
    }

    ngAfterViewInit() {
        this.navbarFooterService.navbar.leftNavbarItems = [
            {
                label: "Preview",
                template: this.templates[CclNavbarTemplates.buttonShort],
                itemStyle: "primary",
                message: "attendee-preview"
            }
        ];
        this.navbarFooterService.navbar.rightNavbarItems = [
            {
                label: "NEXT STEP: Choosing a Theme",
                template: this.templates[CclNavbarTemplates.title],
                itemStyle: "footer"
            },
            {
                label: "SAVE",
                template: this.templates[CclNavbarTemplates.buttonShort],
                itemStyle: "primary",
                message: "save-element"
            },
            {
                label: "SAVE & NEXT",
                template: this.templates[CclNavbarTemplates.buttonShort],
                itemStyle: "primary",
                message: "save-next-element"
            }
        ];
        this.updatePublishButton();
        this.router.navigate(["/admin/" + sessionStorage.getItem("catalogUUID") + "/catalog/setting/page-element"]);
    }

    updatePublishButton() {
        if (this.sharedService.setup != null && this.navSecondaryService.navbar != null) {
            if ((this.sharedService.setup.publishedModifiedDate != this.sharedService.setup.dateModified) || this.sharedService.createSaveFilter) {
                let publiishedDateTitle = "Last published on: " + this.datePipe.transform(this.sharedService.setup.publishedModifiedDate, "EEEE MMMM dd, yyyy • hh:mm a");
                this.navSecondaryService.navbar.rightNavbarItems = [{
                    label: "There are some unpublished changes.",
                    template: this.navbarItemTitleCustom,
                    itemStyle: "context",
                    alt: publiishedDateTitle
                },
                {
                    label: "Publish",
                    template: this.templates[CclNavbarTemplates.buttonShort],
                    itemStyle: "secondary",
                    message: "publish-catalog"
                }];
            } else {
                let publiishedDate = moment(new Date(this.sharedService.setup.publishedModifiedDate)).fromNow();
                let publiishedDateTitle = "Last published on: " + this.datePipe.transform(this.sharedService.setup.publishedModifiedDate, "EEEE MMMM dd, yyyy • hh:mm a");
                this.navSecondaryService.navbar.rightNavbarItems = [{
                    label: "Published (" + publiishedDate + ")",
                    template: this.navbarItemTitleCustom,
                    itemStyle: "context",
                    alt: publiishedDateTitle
                }]
            }
            if (this.sharedService.setup.isPublished) {
                this.navSecondaryService.navbar.rightNavbarItems.push({
                    label: "Launch catalog",
                    template: this.navbarItemExternalLinkCustom,
                    itemStyle: "ccl__external_link",
                    message: "launch-published-catalog"
                });
            }
        }
    }

    ngOnInit(): void {}

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    handleMessage(message) {
        if (message.text == "attendee-preview") {
            let url = document.location.protocol + "//" + document.location.hostname;
            window.open(url + "/session_catalog/#/preview/" + this.sharedService.setup.uuid, "_blank");
        } else if (message.text == "update-publish-button") {
            this.updatePublishButton();
        }
    }

    sendMessage(message): void {
        this.messageService.sendMessage(message);
    }
}
